import ShareButton from './share-button'

export default {
  components: { ShareButton },

  props: {
    channelSettings: {
      type: Object,
      required: true
    },

    entityType: {
      type: String,
      required: true
    },

    entitySlug: {
      type: String,
      required: false
    },

    utmMedium: {
      type: String,
      required: false
    }
  }
}
